import { Link } from 'gatsby';
import React from 'react';

export default function ListContact({ page, img, imgPath }) {
  const lowerPage = page.toLowerCase();
  return (
    <div>
      {img ? (
        <Link
          to={`/${lowerPage}`}
          className={`infos ${lowerPage} link-list imgLink`}
        >
          <li>
            <img src={imgPath} className="vignette" alt="" />
          </li>
        </Link>
      ) : (
        <Link to={`/${lowerPage}`} className={`infos ${lowerPage} link-list`}>
          <li>{`${lowerPage[0].toUpperCase()}${lowerPage
            .substring(1)
            .toLowerCase()}`}</li>
        </Link>
      )}
    </div>
  );
}
